export enum WatchTriggerActionType {
    /**
     * Add option to select
     * type: [0]
     */
    AddOption,
    /**
     * Calls disptach method with action
     * type: [1]
     */
    Dispatch,
    /**
     * Remove option from select
     * type: [2]
     */
    RemoveOption,
    /**
     * Nothing trigger
     * type: [3]
     */
    None,
    /**
     * Show target
     * type: [4]
     */
    Show,
    /**
     * Hide target
     * type: [5]
     */
    Hide,
    /**
     * Remove from view target
     * type: [6]
     */
    Remove,
    /**
     * Add attribute to form field
     * type: [7]
     */
    AddAttribute,
    /**
     * Remove attribute from form
     * type: [8]
     */
    RemoveAttribute,
    /**
     * Load files frome extenral source (payment page)
     * type: [9]
     */
    LoadFields,
    /**
     * Gets price for payment page
     * type: [10]
     */
    GetPrice,
    /**
     * Parse fields - where information
     * type: [11]
     */
    ParseFields,
    /**
     * Process quote
     * type: [12]
     */
    ProcessQuote,
    /**
     * Update transaction event
     * type: [13]
     */
    UpdateTransaction
  }

// Begin data types for dataLayer events
/**
 * allowed event types for GTM
 */
export enum DataEvents {
  testEvent,
  /**
   * analytics event
   */
  analyticsEvent,
}

export enum EcommerceEvents {
  purchase,
}

/**
 * allowed event categories for GTM
 */
export enum DataCategories {
  'Test Category',
  'Quote Journey',
}

/**
 * allowed event actions for GTM
 */
export enum DataActions {
  'Test action',
  /**
   * when user clicks retrieve password button in banner
   */
  'Retrieve password',
  /**
   * when user clicks button to go to their account in banner
   */
  'Go to my account',
  /**
   * when user clicks button to close the banner
   */
  'Close tray',
  /**
   * when user clicks button to amend quote by changing options
   */
  'Change options',
  /**
   * when user clicks button to view a detailed summary of their quote
   */
  'View detailed summary',
  /**
   * when user clicks button to call the Kingsbridge phone number
   */
  'Click to call',
  /**
   * when user lands on a stage or progresses to a substage
   */
  'Progression',
}

/**
 * new GA4 specific custom events
 */
export enum CustomDataEvents {
  quote_seen_buy,
  quote_started_buy,
  quote_bought_buy,
  quote_details_collected_buy,
  quote_seen_renewal,
  quote_started_renewal,
  quote_bought_renewal,
  quote_details_collected_renewal,
}
